import { Pipe, PipeTransform } from '@angular/core';
import { environment } from '../../environments/environment';

@Pipe({ name: 'getEnv' })
export class getEnv implements PipeTransform {
  transform(variable: string): any {
    return environment[variable];
  }
}
